export default __webpack_public_path__ + "static/media/loader.c3e10510.gif";